import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EnrollmentSourceList } from './interface/enrollment-source.interface';

@Injectable()
export class EnrollmentSourceService {
    constructor(private http: HttpClient) {}

    get(): Observable<EnrollmentSourceList> {
        return this.http.get<EnrollmentSourceList>('/api/enrollmentSource');
    }
}
